export const getErrorMessage = (addToWalletErrorCode: number) => {
  switch (addToWalletErrorCode) {
    case 500:
      return 'We ran into an issue, please try adding to your wallet again';
    case 400:
    case 401:
      return 'This coupon may have already been redeemed, please refresh the page and try again';
    case 404:
      return 'This coupon cannot be added to wallet currently. Please try again later.';
    case 409:
      return 'We ran into an issue, please try adding to your wallet again';
    default:
      return 'There was an error retrieving add to wallet link';
  }
};
